import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhAlgorithm } from 'vhautowebdb';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { EditNameComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';
// import { EditNameComponent } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';

@Component({
  selector: 'atw-frame-website-admin',
  templateUrl: './frame-website-admin.component.html',
  styleUrls: ['./frame-website-admin.component.scss'],
})

export class AtwFrameWebsiteAdmin {
  @Input() data;
  @Input() type;

  tableHeight: string; // biến dùng để chứa chiều cao của bảng dữ liệu
  loadingObject = false; // ẩn hiện loading get sp từ DB
  loadingObjectModal = false; // ẩn hiện loading get sp từ DB
  id_category = 'all' // danh mục được chọn để xem dữ liệu sp
  id_category_selected = 'all' // danh mục được chọn để xem dữ liệu sp
  categories: Array<any> = []; // mảng chứa danh mục
  name_main_sector = ''; // tên nhóm (vd: món ăn, sản phẩm, ...)
  /** Mảng chứa số lượng sản phẩm hiển thị trong 1 trang */
  numberPerPage = [5, 10, 20, 50, 100];
  /** Trang người dùng chuyển tới hiển thị */
  pageGoto: number = 1;


  /** Trạng thái mở modal */
  isShowModal = false;
  /** Mảng chứa sản phẩm sẽ hiển thị trong block */
  shownInFrameObjects: any[] = [];
  /** Mảng chứa sản phẩm sau khi search trong shownInFrameObjects */
  searchedObjects: any[] = [];
  /** Tên sản phẩm search trong shownInFrameObjects */
  searchNameObject: string = '';
  /** Tên sản phẩm search trong modal */
  searchNameObjectModal: string = '';
  /** Chứa tất cả sản phẩm hiển thị trong modal */
  shownObjectsModal: any[] = [];
  /** Chứa các sản phẩm sau khi search trong shownObjectsModal */
  searchedObjectsModal: any[] = [];
  /** sắp xếp danh sách sản phẩm trong table, true. A->Z, false. Z->A */
  isASC: boolean = true;
  /** sắp xếp danh sách sản phẩm trong modal, true. A->Z, false. Z->A */
  isASCModal: boolean = true;

  /** Giới hạn sản phẩm hiển thị trong block */
  limitBlock: number = 20;
  /** Giới hạn sản phẩm hiển thị trong modal */
  limitModal: number = 20;
  /** Trang hiện tại trong block */
  pageCurrentBlock: number = 1;
  /** Trang hiện tại trong modal */
  pageCurrentModal: number = 1;
  /** Tổng số trang sản phẩm trong block */
  totalPagesBlock: number = 1;
  /** Tổng số trang sản phẩm trong modal */
  totalPagesModal: number = 1;
  /** Số trang hiển thị trong block */
  pageShowChooseBlock: any = [0, 1, 2];
  /** Số trang hiển thị trong modal */
  pageShowChooseModal: any = [0, 1, 2];
  /** Danh sách sản phẩm khi search block */
  dataSearchedBlock: any = []
  /** Danh sách sản phẩm khi search modal */
  dataSearchedModal: any = []


  constructor(
    public vhAlgorithm: VhAlgorithm,
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private changeDetectorRef: ChangeDetectorRef,
    public functionService: FunctionService,
    private matDialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {
    if(this.data) {
      switch (this.data.id_main_sector) {
        case 'ecommerce': this.name_main_sector = 'san_pham'; break;
        case 'food_drink': this.name_main_sector = 'mon_an'; break;
        case 'website': this.name_main_sector = 'website'; break;
        case 'news': this.name_main_sector = 'tin_tuc'; break;
        case 'service': this.name_main_sector = 'dich_vu'; break;
        case 'recruitment': this.name_main_sector = 'tuyen_dung'; break;
        case 'webapp': this.name_main_sector = 'app'; break;
      }
      
      this.sortProductsBlock()
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId))
      if (this.data) {
        this.id_category = 'all';
        this.shownObjectsModal = [];
        // lấy tên nhóm
        switch (this.data.id_main_sector) {
          case 'ecommerce': this.name_main_sector = 'san_pham'; break;
          case 'food_drink': this.name_main_sector = 'mon_an'; break;
          case 'website': this.name_main_sector = 'website'; break;
          case 'news': this.name_main_sector = 'tin_tuc'; break;
          case 'service': this.name_main_sector = 'dich_vu'; break;
          case 'recruitment': this.name_main_sector = 'tuyen_dung'; break;
          case 'webapp': this.name_main_sector = 'app'; break;
        }

        this.sortProductsBlock();
      }
  }


  ngAfterViewChecked() {
    if (isPlatformBrowser(this.platformId))
      if (
        document.querySelector('#purchase-invoice-today') &&
        document.querySelector('.ant-table-thead') &&
        document.querySelector('.purchase-invoice-today-header')
      ) {
        this.tableHeight =
          document.querySelector('#purchase-invoice-today').clientHeight -
          document.querySelector('.ant-table-thead').clientHeight -
          document.querySelector('.purchase-invoice-today-header').clientHeight -
          100 +
          'px';
      }
    this.changeDetectorRef.detectChanges();
  }


  /**
   * Hàm này get dữ liệu sản phẩm đã gán vào block (đã chọn để hiển thị lên block)
   */
  getProductsBlock(sort, pageCurrent) {
    this.loadingObject = true;
    let query = JSON.parse('{"' + this.data._id + '_hidden":{"$eq": true} }');
    this.vhQueryAutoWeb
      .getWebApps_byFields(query, {}, sort, this.limitBlock, pageCurrent)
      .then((response: any) => {
        let products = response.data;
        for (let i in products) {
          products[i]['show_expand'] = false;

          if (products[i].units) {
            products[i].unitDefault = products[i].units.find(
              (item) => item.default == true
            );
          }
          if (products[i].subs) {
            if (products[i].subs.length) {
              products[i].subs.forEach((element) => {
                if (element.units) {
                  element['unitDefault'] = element.units.find((e) => e.default);
                }
              });
            }
          }
        }

        this.shownInFrameObjects = products;
        this.searchedObjects = products;
        this.totalPagesBlock = response.totalpages;
        this.loadingObject = false;
      });
  }


  /** 
   * Hàm thực hiện cập nhật trạng thái sản phẩm hiển thị trong frame (show_web)
   *
   * @param id
   * @param event
   */
  updateShowWeb(item, value) {
    let data = {
      [`${this.data._id}_hidden`]: value,
      [this.data._id + '_ordinal_number']: 1,
    };

    item[this.data._id + '_ordinal_number'] = 1;

    this.vhQueryAutoWeb.updateWebApp(item._id, data).then((bool) => {
      // Nếu update thành công
      if (bool) {
        // nếu value là true, tức là thêm vào table các website sẽ hiện lên frame
        if (value) {
          this.shownInFrameObjects = this.shownInFrameObjects.concat(item);
          this.searchedObjects = this.shownInFrameObjects;
          this.transferFn(this.pageCurrentBlock === 0 ? 1 : this.pageCurrentBlock);
        }
        else {
          // ngược lại xóa khỏi table các sản phẩm sẽ hiện lên frame
          this.shownInFrameObjects = this.shownInFrameObjects.filter(
            (e) => (e._id != item._id)
          );
          this.searchedObjects = this.shownInFrameObjects;
          // Nếu xóa hết sản phẩm trong block
          if (this.shownInFrameObjects.length === 0) {
            if (this.pageCurrentBlock === this.totalPagesBlock) {
              this.transferFn(this.pageCurrentBlock - 1);
            }
            else {
              this.transferFn(this.pageCurrentBlock);
            }
          }
        }
      }
    });
  }


  /**
   * Tìm sản phẩm trong table
   */
  onSearchBlock(value) {
    this.id_category = this.id_category_selected = 'all';
    this.resetPaginationBlock();
    this.vhQueryAutoWeb.searchList_likeSearch('webapps', 'name_' + this.functionService.defaultLanguage, this.searchNameObject, { [this.data._id + '_hidden']: { $eq: true } }, {})
      .then((res: any) => {
        console.log('res', res);
        if (res.vcode === 0) {
          // this.dataSearchedBlock = res.data.filter(item => item[this.data._id + '_hidden'] === true);
          this.dataSearchedBlock = res.data;

          // cập nhật lại dữ liệu     
          this.dataSearchedBlock.forEach((product) => {
            product.show_expand = false;

            if (product.units) {
              product.unitDefault = product.units.find(
                (item) => item.default == true
              );
            }

            if (product.subs && product.subs.length) {
              product.subs.forEach((sub) => {
                sub.unitDefault = sub?.units?.find((e) => e.default);
              });
            }
          });

          this.searchedObjects = this.handlePaginateLocalBlock();
        }
      }, (error: any) => {
        console.log('error', error)
      })

  }


  handlePaginateLocalBlock() {
    let data_filter = this.id_category == 'all' ? this.dataSearchedBlock : this.dataSearchedBlock.filter(item => item.id_categorys.includes(this.id_category))
    data_filter = this.isASC ? this.vhAlgorithm.sortStringbyASC(data_filter, 'name_' + this.functionService.defaultLanguage) : this.vhAlgorithm.sortStringbyDESC(data_filter, 'name_' + this.functionService.defaultLanguage)
    let data_page = new Array(); //mảng dữ liệu phân theo page
    for (let i = 0; i < data_filter.length; i++) {
      if ((i >= this.limitBlock * (this.pageCurrentBlock - 1)) && (i < this.limitBlock * this.pageCurrentBlock)) data_page.push(data_filter[i]);
    }
    this.totalPagesBlock = Math.ceil(data_filter.length / this.limitBlock); // tổng số page

    return data_page
  }


  /**
   * hàm này reset pagination về 1
   */
  resetPaginationBlock() {
    this.pageCurrentBlock = 1;
    this.pageGoto = 1;
    this.pageShowChooseBlock = [0, 1, 2];
  }



  /**
   * Cập nhật thứ tự của Vị trí hiển thị
   */
  updateOrder(item, value) {
    this.vhQueryAutoWeb
      .updateWebApp(item._id, { [this.data._id + '_ordinal_number']: value })
      .then((bool) => {

      });
  }


  /* ------------------------- Phân trang trong block ------------------------- */

  /** 
   * Chuyển trang đến trang trước
   */
  gotoPreviousPage() {
    if (this.pageCurrentBlock > 1) {
      this.transferFn(this.pageCurrentBlock - 1);
    } else if (this.pageCurrentBlock == 1) {
      this.transferFn(this.totalPagesBlock);
    }
  }


  /** 
   * Chuyển trang đến trang sau
   */
  gotoNextPage() {
    if (this.pageCurrentBlock < this.totalPagesBlock) {
      this.transferFn(this.pageCurrentBlock + 1);
    } else if ((this.pageCurrentBlock = this.totalPagesBlock)) {
      this.transferFn(1);
    }
  }


  /** 
   * Chuyển đến trang cụ thể
   *
   * @param value trang cần chuyển đến
   */
  transferFn(value: number) {
    this.pageCurrentBlock = Number(value);
    this.pageGoto = Number(value);

    if (this.searchNameObject && this.dataSearchedBlock.length) {
      this.searchedObjects = this.handlePaginateLocalBlock();
    } else this.sortProductsBlock();

    // Thay đổi giá trị trang cho người dùng chọn
    if (this.pageCurrentBlock < this.totalPagesBlock && this.pageCurrentBlock > 1) {
      this.pageShowChooseBlock = this.pageShowChooseBlock.map((num, index) => {
        return (num = this.pageCurrentBlock + index - 1);
      });
    }
    else {
      this.pageShowChooseBlock = this.pageShowChooseBlock.map((_, index) => this.pageCurrentBlock + index - 1);
    }
  }

  handleSortBlock() {
    this.isASC = !this.isASC;

    if (this.searchNameObject && this.dataSearchedBlock.length) {
      this.searchedObjects = this.handlePaginateLocalBlock();
    } else {
      this.sortProductsBlock()
    }
  }


  /**
   * Sắp xếp sản phẩm theo thứ tự
   */
  sortProductsBlock() {
    this.getProductsBlock({ ['name_' + this.functionService.defaultLanguage]: this.isASC ? 1 : -1 }, this.pageCurrentBlock);
  }


  /**
   * Xử lý khi chọn limit sản phẩm hiển thị trong block
   */
  handleChangeLimitBlock() {
    if (this.searchNameObject) {
      this.resetPaginationBlock();
      this.searchedObjects = this.handlePaginateLocalBlock();
    } else this.transferFn(1);
  }



  /* -------------------------------------------------------------------------- */
  /*                             CÁC HÀM TRONG MODAL                            */
  /* -------------------------------------------------------------------------- */

  /**
   * Mở hộp thoại chọn sản phẩm hiển thị trong frame
   */
  showModal() {
    this.isShowModal = true;
    this.getCategory();
    this.id_category = 'all';
    this.searchedObjectsModal = [];
  }


  /**
   * Hàm này get danh sách category để chọn xem sản phẩm theo danh mục
   * @example this.getCategory()
   */
  getCategory() {
    this.vhQueryAutoWeb.getCategorys_byFields({ id_main_sectors: { $all: ['webapp'] } }, {}, {}, 0)
      .then((res: any) => {
        this.categories = res.data.map((e) => {
          return {
            ...e,
            array_step: Array(e.step)
              .fill(0)
              .map((_, i) => i),
          };
        });
      });
  }


  /**
   * Tạo gạch ngang phân cấp danh mục
   * @param array 
   * @returns 
   */
  generateSymBol(array: []) {
    let string = '';
    array.forEach((_) => {
      string = string + `- `;
    });
    return string;
  }


  /** 
   * Hàm thực hiện lấy danh sách sản phẩm theo category dung trong modal
   */
  getProductsModal(sort, pageCurrent?: number) {
    this.loadingObjectModal = true;
    this.searchNameObjectModal = '';
    if (this.id_category != this.id_category_selected) {
      this.resetPaginationModal();
      this.id_category_selected = this.id_category;
    }

    let query =
      this.id_category == 'all' ? {} : { id_categorys: { $all: [this.id_category] }, }
    this.vhQueryAutoWeb.getWebApps_byFields(
      query,
      {},
      sort,
      this.limitModal,
      pageCurrent
    )
      .then((response: any) => {
        let products = response.data;
        for (let i in products) {
          products[i]['show_expand'] = false;

          if (products[i].units) {
            products[i].unitDefault = products[i].units.find(
              (item) => item.default == true
            );
          }
          if (products[i].subs) {
            if (products[i].subs.length) {
              products[i].subs.forEach((element) => {
                if (element.units) {
                  element['unitDefault'] = element.units.find((e) => e.default);
                }
              });
            }
          }
        }

        this.shownObjectsModal = products;
        this.searchedObjectsModal = products;
        this.loadingObjectModal = false;
        this.totalPagesModal = response.totalpages;
      });
  }


  /**
   * Tìm sản phẩm theo danh mục trong modal
   */
  onSearchModal(value) {
    this.resetPaginationModal();
    this.vhQueryAutoWeb.searchList_likeSearch('webapps', 'name_' + this.functionService.defaultLanguage, this.searchNameObjectModal, {}, {})
      .then((res: any) => {
        console.log('res', res);
        if (res.vcode === 0) {
          this.dataSearchedModal = res.data;

          // cập nhật lại dữ liệu     
          this.dataSearchedModal.forEach((product) => {
            product.show_expand = false;

            if (product.units) {
              product.unitDefault = product.units.find(
                (item) => item.default == true
              );
            }

            if (product.subs && product.subs.length) {
              product.subs.forEach((sub) => {
                sub.unitDefault = sub?.units?.find((e) => e.default);
              });
            }
          });



          this.searchedObjectsModal = this.handlePaginateLocalModal();
        }
      }, (error: any) => {
        console.log('error', error)
      })
  }

  /**
     * hàm này reset pagination về 1
     */
  resetPaginationModal() {
    this.pageCurrentModal = 1;
    this.pageGoto = 1;
    this.pageShowChooseModal = [0, 1, 2];
  }


  handlePaginateLocalModal() {
    let data_filter = this.id_category == 'all' ? this.dataSearchedModal : this.dataSearchedModal.filter(item => item.id_categorys.includes(this.id_category))
    data_filter = this.isASCModal ? this.vhAlgorithm.sortStringbyASC(data_filter, 'name_' + this.functionService.defaultLanguage) : this.vhAlgorithm.sortStringbyDESC(data_filter, 'name_' + this.functionService.defaultLanguage)
    let data_page = new Array(); //mảng dữ liệu phân theo page
    for (let i = 0; i < data_filter.length; i++) {
      if ((i >= this.limitModal * (this.pageCurrentModal - 1)) && (i < this.limitModal * this.pageCurrentModal)) data_page.push(data_filter[i]);
    }
    this.totalPagesModal = Math.ceil(data_filter.length / this.limitModal); // tổng số page

    return data_page
  }


  trackByFn(index: number, item: any) {
    return item.id; // hoặc sử dụng một thuộc tính duy nhất khác của item
  }


  /* ------------------------- Phân trang trong modal ------------------------- */

  /**
   * Di chuyển đến trang trước trong modal
   */
  gotoPreviousPageModal() {
    if (this.pageCurrentModal > 1) {
      this.transferFnModal(this.pageCurrentModal - 1);
    }
    else if (this.pageCurrentModal == 1) {
      this.transferFnModal(this.totalPagesModal);
    }
  }


  /**
   * Di chuyển đến trang sau trong modal
   */
  gotoNextPageModal() {
    if (this.pageCurrentModal < this.totalPagesModal) {
      this.transferFnModal(this.pageCurrentModal + 1);
    } else if ((this.pageCurrentModal = this.totalPagesModal)) {
      this.transferFnModal(1);
    }
  }


  /**
   * Chuyển đến trang cụ thể trong modal
   * @param pageCurrent trang cần chuyển đến
   */
  transferFnModal(pageCurrent: number) {
    this.pageCurrentModal = Number(pageCurrent);
    this.pageGoto = Number(pageCurrent);

    if (this.searchNameObjectModal && this.dataSearchedModal.length) {
      this.searchedObjectsModal = this.handlePaginateLocalModal();
    } else this.sortProductsModal();

    // Thay đổi giá trị trang cho người dùng chọn
    if (this.pageCurrentModal < this.totalPagesModal && this.pageCurrentModal > 1) {
      this.pageShowChooseModal = this.pageShowChooseModal.map((num, index) => {
        return (num = this.pageCurrentModal + index - 1);
      });
    }
    else {
      this.pageShowChooseModal = this.pageShowChooseModal.map((_, index) => this.pageCurrentModal + index - 1);
    }
  }

  handleChangeCategoryFilterModal() {
    this.totalPagesModal = 1;
    this.searchNameObjectModal = '';
    this.searchedObjectsModal = [];
  }



  /**
   * Lấy danh sách sản phẩm trong modal được sắp xếp theo tên
   */
  sortProductsModal() {
    this.getProductsModal({ ['name_' + this.functionService.defaultLanguage]: this.isASCModal ? 1 : -1 }, this.pageCurrentModal);
  }


  /**
   * Xử lý khi chọn limit sản phẩm hiển thị trong modal
   */
  handleChangeLimitModal() {
    if (this.searchNameObjectModal) {
      this.resetPaginationModal();
      this.searchedObjectsModal = this.handlePaginateLocalModal();
    } this.transferFnModal(1);
  }

  handleSortModal() {
    this.isASCModal = !this.isASCModal;
    if (this.searchNameObjectModal && this.dataSearchedModal.length) {
      this.searchedObjectsModal = this.handlePaginateLocalModal();
    } else this.sortProductsModal()
  }





  /**
   * Hàm mở ra hộp thoại chỉnh sửa tên và update data
   * @param object 
   */
  editNameObject(object: any) {
    this.matDialog
      .open(EditNameComponent, {
        width: '20%',
        data: object.name || this.data.name,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.data.name = result;
          this.updateObject();
        }
      });
  }


  /**
   * Update dữ liệu của 
   */
  updateObject() {
    if (this.type == 'admin') {
      if (!this.data.hasOwnProperty('fieldUpdate')) this.data['fieldUpdate'] = []
      if (!this.data['fieldUpdate'].includes('name')) this.data['fieldUpdate'].push('name')
      return;
    }
    this.vhQueryAutoWeb.updateObject(this.data._id, { name: this.data.name })
      .then((bool) => {
        // console.log('bool', bool);
      },
        (error) => {
          console.log('error', error);
          this.functionService.createMessage('error', 'cap_nhat_du_lieu_that_bai');
        }
      );
  }

}
